import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type Variant = 'primary' | 'outlineDark' | 'outlineLight' | 'solidDark';
interface ButtonLinkProps {
  to: string;
  children: React.ReactNode;
  variant?: Variant;
  withArrow?: boolean;
  className?: string;
  onClick?: () => void;
}
const variantClasses: Record<Variant, string> = {
  primary: 'bg-champagne-300 text-midnight-950 hover:bg-champagne-200',
  outlineDark: 'border border-champagne-300/40 text-champagne-100 hover:border-champagne-300 hover:bg-champagne-300/10',
  outlineLight: 'border border-midnight-900/25 text-midnight-900 hover:border-midnight-900 hover:bg-midnight-900/5',
  solidDark: 'bg-midnight-900 text-champagne-50 hover:bg-midnight-800'
};
export function ButtonLink({
  to,
  children,
  variant = 'primary',
  withArrow = false,
  className = '',
  onClick
}: ButtonLinkProps) {
  return <Link to={to} onClick={onClick} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-medium transition-[background-color,border-color,color] duration-150 ease-out ${variantClasses[variant]} ${className}`} data-id="element-28" data-mp="2chx57d3cvue9">
      {children}
      {withArrow && <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-29" data-mp="hkv7ddaif5g" />}
    </Link>;
}